import type { MemberAccessRule } from './types.js';

export const RUBY_MEMBER_ACCESS_RULES: MemberAccessRule[] = [
  { parentType: 'call', objectField: 'receiver', propertyField: 'method', tagKind: 'call' },
];
